import { LeadSearchPage } from '@/features/leads/routes/LeadSearchPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/$filter/')({
  component: LeadSearchPage,
});
